"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _colors = _interopRequireDefault(require("./colors"));

var _space = _interopRequireDefault(require("./space"));

var _fontSizes = _interopRequireDefault(require("./fontSizes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PILL_CONFIG = {
  pills: {
    "default": {
      backgroundColor: _colors["default"].teal[200],
      color: _colors["default"].teal[900],
      '& > i': {
        backgroundColor: _colors["default"].teal[200],
        color: _colors["default"].teal[400],
        '&:hover': {
          color: _colors["default"].teal[500]
        }
      }
    },
    secondary: {
      borderColor: _colors["default"].blue[300],
      backgroundColor: _colors["default"].blue[200],
      color: _colors["default"].blue[900],
      '& > i': {
        backgroundColor: _colors["default"].blue[200],
        color: _colors["default"].blue[400],
        '&:hover': {
          color: _colors["default"].blue[500]
        }
      }
    },
    neutral: {
      borderColor: _colors["default"].neutral[300],
      backgroundColor: _colors["default"].neutral[200],
      color: _colors["default"].neutral[900],
      '& > i': {
        backgroundColor: _colors["default"].neutral[200],
        color: _colors["default"].neutral[400],
        '&:hover': {
          color: _colors["default"].neutral[500]
        }
      }
    },
    warn: {
      borderColor: _colors["default"].yellow[300],
      backgroundColor: _colors["default"].yellow[200],
      color: _colors["default"].yellow[900],
      '& > i': {
        backgroundColor: _colors["default"].yellow[200],
        color: _colors["default"].yellow[400],
        '&:hover': {
          color: _colors["default"].yellow[500]
        }
      }
    },
    danger: {
      borderColor: _colors["default"].red[300],
      backgroundColor: _colors["default"].red[200],
      color: _colors["default"].red[800],
      '& > i': {
        backgroundColor: _colors["default"].red[200],
        color: _colors["default"].red[400],
        '&:hover': {
          color: _colors["default"].red[500]
        }
      }
    },
    transparent: {
      borderColor: 'transparent',
      backgroundColor: 'transparent',
      color: _colors["default"].neutral[900],
      '& > i': {
        backgroundColor: 'transparent',
        color: _colors["default"].red[400],
        '&:hover': {
          color: _colors["default"].red[500]
        }
      }
    }
  },
  pillSizes: {
    medium: {
      paddingLeft: _space["default"][4],
      paddingRight: _space["default"][4],
      fontSize: _fontSizes["default"][1],
      minHeight: 32,
      '& > i': {
        marginRight: -_space["default"][3]
      }
    },
    small: {
      paddingLeft: _space["default"][2],
      paddingRight: _space["default"][2],
      fontSize: _fontSizes["default"][1],
      minHeight: 24,
      '& > i': {
        marginRight: -_space["default"][1]
      }
    }
  }
};
var _default = PILL_CONFIG;
exports["default"] = _default;